import { useState } from "react";
import { getAllUsers } from "../api/UserApi";

const useUserList = () => {
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const fetchUserList = async (page, limit, search) => {
    try {
      setLoading(true);
      const res = await getAllUsers(page, limit, search);
      console.log("user list fetch :", res);
      setUserList(res?.data?.formattedUsers || []);
      setTotalPages(res?.data?.totalPages || 1);
      return res;
    } catch (error) {
      console.error("error on get user list:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchUserList,
    userList,
    loading,
    totalPages,
  };
};

export default useUserList;
